import AsyncStorage from '@react-native-async-storage/async-storage';
import { parseCareTask, type CareTask } from './careTask';

const STORAGE_KEY = '@eleplan/pending_care_task';
const TTL_MS = 24 * 60 * 60 * 1000;

/** Like registration prefills, this survives OAuth, verification and plan setup. */
export async function setPendingCareTask(value: Record<string, unknown>): Promise<void> {
  const task = parseCareTask(value);
  if (!task) return;
  try {
    await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify({ task, savedAt: Date.now() }));
  } catch { /* Signup still works when local storage is unavailable. */ }
}

export async function getPendingCareTask(): Promise<CareTask | null> {
  try {
    const raw = await AsyncStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const stored = JSON.parse(raw);
    const task = parseCareTask(stored?.task);
    const age = Date.now() - stored?.savedAt;
    if (!task || !Number.isFinite(age) || typeof stored?.savedAt !== 'number' || age < 0 || age > TTL_MS) {
      await AsyncStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return task;
  } catch { return null; }
}

export async function clearPendingCareTask(expected: CareTask): Promise<void> {
  try {
    const current = await getPendingCareTask();
    if (current?.care_task !== expected.care_task || current?.care_topic !== expected.care_topic) return;
    await AsyncStorage.removeItem(STORAGE_KEY);
  } catch { /* The short expiry also bounds a failed clear. */ }
}
